// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"breadCrumbs__2Rqjq","tooltip":"tooltip__3MjzG","hint":"hint__3wswd","sendButton":"sendButton__3Tcjf","actionsSelect":"actionsSelect__1QFTR"};